import _ from 'lodash';
import {
    NEXT_STEP,
    PREVIOUS_STEP,
    SET_STEP,
    SET_IS_ERROR_POPUP_VISIBLE,
    SET_IS_LOADING,
    SET_IS_PDF_GENERATING,
    SET_PDF_URL,
    SET_CHECKOUT_BEHAVIOUR,
    SET_CHECKOUT_DEFAULTS,
} from '../actions/actionCreators/checkout';

const initialState = {
    step: 0,
    pdfUrl: null,
    isErrorPopupVisible: false,
    isPdfGenerating: false,
    isLoading: false,
    behaviour: 'DEFAULT',
};

export default function app(state = initialState, action) {
    let newState = _.cloneDeep(state);
    switch (action.type) {
        case NEXT_STEP:
            newState.step = state.step + 1;
            return newState;
        case PREVIOUS_STEP:
            newState.step = state.step - 1;
            return newState;
        case SET_STEP:
            newState.step = action.step;
            return newState;
        case SET_IS_ERROR_POPUP_VISIBLE:
            newState.isErrorPopupVisible = action.isErrorPopupVisible;
            return newState;
        case SET_IS_PDF_GENERATING:
            newState.isPdfGenerating = action.isPdfGenerating;
            return newState;
        case SET_PDF_URL:
            newState.pdfUrl = action.pdfUrl;
            return newState;
        case SET_IS_LOADING:
            newState.isLoading = action.isLoading;
            return newState;
        case SET_CHECKOUT_BEHAVIOUR:
            newState.behaviour = action.behaviour;
            return newState;
        case SET_CHECKOUT_DEFAULTS:
            return initialState;
        default:
            return state;
    }
}
